import classNames from "classnames";
import * as React from "react";
import { Link } from "react-router-dom";
import CircleIcon from "../../../components/atoms/CircleIcon";
import Loader from "../../../components/atoms/Loader/index";
import TabsNavi from "../../../components/molecules/TabsNavi/index";
import { truncate } from "../../../helpers/String";
import TimeHelper from "../../../helpers/TimeHelper";
import { CommentInterface } from "../../../interfaces/CommentInterface";
import styles from "./styles.scss";

interface Props {
  allComments: CommentInterface[];
  loading: boolean;
}

interface CommentItemProps {
  comment: CommentInterface;
}

interface NotificationDataProps {
  comment: CommentInterface;
}

const NotificationData: React.FC<NotificationDataProps> = ({ comment }) => {
  const { studyRecord, body } = comment;
  const { fullName } = comment.student;

  return (
    <span>
      <span className={styles.bold}>{fullName}</span>が
      <span className={styles.bold}>
        {TimeHelper.defaultFormat(studyRecord.recordedAt)}
      </span>
      の勉強記録のコメントに返信しました：「{truncate(body, 20)}」
    </span>
  );
};

const CommentItem: React.FC<CommentItemProps> = ({ comment }) => {
  const notificationPath = `/students/${comment.student.id}/study_records/${comment.studyRecord.id}`;

  return (
    <Link
      to={notificationPath}
      className={classNames(styles.item, {
        [styles.highlight]: !comment.isRead,
      })}
    >
      <div className={styles.left}>
        <CircleIcon
          iconProps={{ name: "icon-notice-comment" }}
          className={styles.icon}
        />
      </div>
      <div className={styles.right}>
        <div>
          <NotificationData comment={comment} />
        </div>
        <div className={styles.date}>
          {TimeHelper.defaultFormat(comment.createdAt)}
        </div>
      </div>
    </Link>
  );
};

const SectionStudyRecordComments: React.FC<Props> = ({
  allComments,
  loading,
}) => {
  return (
    <React.Fragment>
      <TabsNavi
        tabs={[
          {
            label: "お知らせ",
            link: `#`,
            active: true,
          },
        ]}
      />
      <div className={styles.list}>
        {allComments.map((comment: CommentInterface) => (
          <CommentItem
            key={`study_record_comment-${comment.id}`}
            comment={comment}
          />
        ))}
      </div>
      <Loader loading={loading} />
    </React.Fragment>
  );
};

export default SectionStudyRecordComments;
